<template>
  <div class="cascade-select">
    <v-layout row>
      <v-flex xs2 class="pa-4 text-xs-right" align-center v-if="label != null">{{ label }}</v-flex>
      <v-flex :class="{ xs10: label != null, xs12: label == null }">
        <template v-for="index in internalValue.length + 1" v-if="struct[index - 1] != null">
          <span v-if="index > 1" :style="{ padding: '0 20px' }">/</span>
          <v-select
            ref="select"
            :menu-props="{ minWidth: '300px', style: 'background: white' }"
            :style="{ width: '100px', display: 'inline-block' }"
            @input="handleSelectInput(index - 1, $event)"
            item-text="label"
            item-value="value"
            :items="struct[index - 1]"
            :value="internalValue[index - 1]"
            :disabled="disabled"
          ></v-select>
        </template>
        <v-btn v-if="disabled != true && value != null" @click="$emit('input', null)" small icon light><v-icon>clear</v-icon></v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'select-cascade',

  props: ['value', 'label', 'items', 'disabled'],

  data: function () {
    return {
      internalValue: this.value != null ? this.value : [],
      internalySet: false,
      struct: []
    }
  },

  mounted () {
    this.$nextTick(function () {
      this.updateStruct()
    })
  },

  watch: {
    value (newValue, oldValue) {
      if (this.internalySet) {
        this.internalySet = false
      } else {
        this.internalValue = newValue || []
      }
    }
  },

  methods: {

    getItem (path) {
      let currItem = { children: this.items }
      for (let p of path) {
        currItem = currItem.children.find(x => x.value == p)
      }
      return currItem
    },

    handleSelectInput (index, value) {
      // Do nothing if same value as previously is selected
      if (this.internalValue[index] == value) {
        return
      }
      let newValue = []
      for (let i = 0; i < index; i++) {
        newValue.push(this.internalValue[i])
      }
      newValue.push(value)
      this.internalValue = newValue
      let commitValue = this.getItem(newValue).children == null ? newValue : null
      this.internalySet = true
      this.$emit('input', commitValue)
      this.updateStruct()
      // console.log(commitValue)
    },

    updateStruct () {
      let index = 0
      let struct = []
      let currVal = this.internalValue[index]
      let currItem = this.getItem([])
      while (currItem.children != null && index <= this.internalValue.length) {
        struct.push(currItem.children)
        index++
        if (currVal != null) {
          currItem = currItem.children.find(x => x.value == currVal)
          currVal = this.internalValue[index]
        } else {
          break
        }
      }
      this.struct = struct
      if (this.internalValue.length > 0) {
        this.$nextTick(function() {
          let lastSelect = this.$refs['select'][this.internalValue.length]
          if (lastSelect != null) {
            lastSelect.activateMenu()
          }
        })
      }
    }

  }

}
</script>
